export const StringUtils = {

  capitalize: value => value && value !== '' ? value.charAt(0).toUpperCase() + value.slice(1) : ''

}

export default StringUtils
